const C = {
  name: "Copy",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 2C3.34315 2 2 3.34315 2 5V13C2 14.6569 3.34315 16 5 16H8V19C8 20.6569 9.34315 22 11 22H19C20.6569 22 22 20.6569 22 19V11C22 9.34315 20.6569 8 19 8H16V5C16 3.34315 14.6569 2 13 2H5ZM14 8H11C9.34315 8 8 9.34315 8 11V14H5C4.44772 14 4 13.5523 4 13V5C4 4.44772 4.44772 4 5 4H13C13.5523 4 14 4.44772 14 5V8ZM10 19V11C10 10.4477 10.4477 10 11 10H19C19.5523 10 20 10.4477 20 11V19C20 19.5523 19.5523 20 19 20H11C10.4477 20 10 19.5523 10 19Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Copy
};
